import React from 'react';
import { Typography } from '@mui/material';

interface ITooltipTitleProps {
  text: string;
}

export const TooltipTitle: React.FC<ITooltipTitleProps> = ({ text }) => {
  const formatTextWithNewlines = (text: string) => {
    return text.split('\n').map((line) => (
      <>
        {line}
        <br />
      </>
    ));
  };

  return (
    <>
      <Typography
        color="white"
        fontWeight={'700'}
        style={{ textShadow: '0px 1px 1px #000' }}
      >
        DROP RATES
      </Typography>
      {formatTextWithNewlines(text)}
    </>
  );
};
